module.exports = __webpack_public_path__ + "img/electrician.e1b3ae53.png";